import { FC, useState, useEffect } from 'react';
import cx from 'classnames/bind';
import { useMediaQuery } from 'react-responsive';

import { Layout } from '@/components/Layout';
import { Button } from '@/components/Button';
import { PointsInfo } from '@/components/PointsInfo';
import Girl from '@/assets/girl.png';
import GirlTablet from '@/assets/girlTablet.png';
import GirlDesktop from '@/assets/girlDesktop.png';
import type { IBoxes } from '@/types/pack';

import styles from './Step1.module.scss';

interface Step1Props {
  setStep: (value: number) => void;
  totalPoints: number;
  isTrainingCompleted?: boolean;
  userToken: string;
}

const cn = cx.bind(styles);

const Step1: FC<Step1Props> = ({
  setStep,
  totalPoints,
  isTrainingCompleted,
  userToken,
}) => {
  const isDesktop = useMediaQuery({ query: '(min-width: 1392px)' });
  const isTablet = useMediaQuery({ query: '(min-width: 786px)' });

  const src = isDesktop ? GirlDesktop : isTablet ? GirlTablet : Girl;

  const startTraining = () => {
    setStep(!isTrainingCompleted ? 3 : 2);
  };

  const [orders, setOrders] = useState<IBoxes[]>();

  useEffect(() => {
    if (userToken) {
      fetch(`https://admin.znatok.jti-games.dev.familyagency.ru/api/orders`, {
        headers: {
          UserToken: userToken,
        },
      })
        .then((response) => response.json())
        .then(({ data }) => setOrders(data));
    }
  }, [userToken]);

  const firstList = orders?.[0]?.orders;
  const secondList = orders?.[1]?.orders;
  const thirdList = orders?.[2]?.orders;

  const list = [
    ...(firstList || []),
    ...(secondList || []),
    ...(thirdList || []),
  ];

  const isAllPointsReceived = list?.every(
    ({ achievement }) => achievement !== null,
  );

  return (
    <Layout className={cn('container')}>
      {isAllPointsReceived ? (
        <PointsInfo text="На данный момент все доступные баллы получены" />
      ) : (
        <PointsInfo
          text="За прохождение вы можете получить"
          points={totalPoints}
        />
      )}

      <div className={cn('content')}>
        <h1 className={cn('title')}>Знаток продукции</h1>
        <p className={cn('description')}>
          Проверьте знание продукции JTI! <br /> Получайте эксперт-баллы, верно
          указывая характеристики продукта
        </p>
      </div>
      <div className={cn('content-bottom')}>
        <img src={src} className={cn('img')} alt="Девушка с коробками" />
        <Button handleClick={startTraining}>Начать</Button>
      </div>
    </Layout>
  );
};

export default Step1;
